import { render, staticRenderFns } from "./PromotionUpdateConfirmModal.vue?vue&type=template&id=0e0b0378&scoped=true&"
import script from "./PromotionUpdateConfirmModal.vue?vue&type=script&lang=js&"
export * from "./PromotionUpdateConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0b0378",
  null
  
)

export default component.exports